import styled from '@emotion/styled';

const StyledDataAccessUsers = styled.div`
  color: pink;
`;

export function DataAccessUsers() {
  return (
    <StyledDataAccessUsers>
      <h1>Welcome to DataAccessUsers!</h1>
    </StyledDataAccessUsers>
  );
}

export default DataAccessUsers;
